import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header';
import Search from '../components/search';
import { publishActions } from '../actions/publishActions';
import { userActions } from '../actions/userActions';
import AdminQuestionGrid from '../components/adminQuestionGrid';
import UserQuestionGrid from '../components/userQuestionGrid';
import EditQuestion from '../components/editQuestion';

export class Publish extends Component {
    constructor(props) {
        super(props)
        this.state = {
            questionId: '',
            questionData: {}
        }
    }

    componentDidMount() {
        this.props.getFilters();
        this.props.authenticateUser();
    }

    handleEditQuestionForm = (questionId = '', questionData = {}) => {
        this.setState({
            questionId,
            questionData,
        });
    }

    render() {
        return (
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content">
                        <Header></Header>
                        {!this.state.questionId && <Search userAuthInfo={this.props.userAuthInfo} filters={this.props.filters}></Search>}
                        {!this.state.questionId && (
                            this.props.userAuthInfo.isAdmin ? (((this.props.searchResult && this.props.searchResult.length) || this.props.fetching) ? <AdminQuestionGrid handleEditQuestionForm={this.handleEditQuestionForm}></AdminQuestionGrid> : '')
                                : <UserQuestionGrid userAuthInfo={this.props.userAuthInfo} filters={this.props.filters} handleEditQuestionForm={this.handleEditQuestionForm}></UserQuestionGrid>
                        )}
                        {this.state.questionId && <EditQuestion currentQuestion={this.state.questionData} handleEditQuestionForm={this.handleEditQuestionForm} filters={this.props.filters} />}
                    </section>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { searchResult, filters } = state.publish;
    const { fetching } = state.notification;
    const { userAuthInfo } = state.user;

    return {
        searchResult,
        fetching,
        filters,
        userAuthInfo,
    };
};

const actionCreators = {
    getFilters: publishActions.getFilters,
    authenticateUser: userActions.authenticateUser,
}

export default connect(mapStateToProps, actionCreators)(Publish);
